import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/timeCard/account/${number | ':accountId'}/bulkAssignEntries`;

export const ROUTE: RouteDefinition = `${baseRoute}/timeCard/account/:accountId/bulkAssignEntries`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/timeCard/account/${accountId}/bulkAssignEntries`;
